import React, { useState, useEffect } from "react";
import Img1 from "./../../assets/residential/Mr. Jerome surya/Mr.Jerome -01-07-2024.jpg";
import Img2 from "./../../assets/residential/Sam/sam house 02 3d.jpg";
import Img3 from "./../../assets/residential/Edward Sundar/edward (3).webp";
import Img4 from "./../../assets/residential/Mr.Munirathinam/photo (6).webp";

const topics = [
  {
    title: "INTER-CONNECTIVITY",
    content:
      "We believe architecture is more than just creating buildings—it’s about <strong>seamlessly connecting spaces, people, and functionality.</strong> Our approach integrates <strong>planning, design, and construction</strong> to craft environments that foster <strong>efficiency, sustainability, and aesthetic excellence.</strong>",
    image: Img1,
  },
  {
    title: "DISTINCTION",
    content:
      "We set ourselves apart by delivering <strong>architectural excellence, engineering precision, and innovative interior solutions.</strong> Our commitment to <strong>quality, sustainability, and functionality</strong> ensures that every project—whether residential, commercial, or industrial—stands as a <strong>testament to timeless design and superior craftsmanship.</strong>",
    image: Img2,
  },
  {
    title: "OPPORTUNITY",
    content:
      "From <strong>residential and commercial spaces to large-scale industrial and institutional projects</strong>, we seize every opportunity to craft <strong>intelligent, future-ready designs</strong> that enhance communities and elevate lifestyles. Our expertise in <strong>architecture, engineering, and interior design</strong> allows us to unlock the full potential of every space, ensuring it serves both <strong>purpose and beauty.</strong>",
    image: Img3,
  },
  {
    title: "HUMANITY",
    content:
      "Every design we craft is rooted in <strong>human-centric principles</strong>, ensuring that our environments are not only functional and aesthetically appealing but also enhance the well-being of the people who inhabit them. From <strong>homes that foster warmth and connection</strong> to <strong>commercial and industrial spaces that promote productivity and collaboration.</strong>",
    image: Img4,
  },
];




const TopicsSection = () => {
  const [selectedTopic, setSelectedTopic] = useState(topics[0]);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = windowWidth <= 768;

  return (
    <div
      style={{
        width: "100%",
       // minHeight: "80vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
        boxSizing: "border-box",
      }}
    >
      {/* Topics Header */}
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: isMobile ? "flex-start" : "space-evenly",
          overflowX: isMobile ? "scroll" : "visible",
          padding: "15px 0",
          position: "relative",
          gap: isMobile ? "10px" : "0",
          whiteSpace: isMobile ? "nowrap" : "normal",
        }}
      >
        {topics.map((topic, index) => (
          <button
            key={index}
            style={{
              fontSize: isMobile ? "1rem" : "1.2rem",
              fontWeight: "bold",
              cursor: "pointer",
              border: "none",
              background: "none",
              color: selectedTopic.title === topic.title ? "#bf1e2e" : "#333",
              transition: "color 0.3s ease-in-out",
              padding: isMobile ? "10px 15px" : "0",
              flex: isMobile ? "0 0 auto" : "1",
              textAlign: "center",
              position: "relative",
            }}
            onClick={() => setSelectedTopic(topic)}
          >
            {topic.title}
            {selectedTopic.title === topic.title && (
              <div
                style={{
                  position: "absolute",
                  bottom: "-8px",
                  left: "0",
                  width: "100%",
                  height: "3px",
                  backgroundColor: "#bf1e2e",
                }}
              ></div>
            )}
          </button>
        ))}
      </div>

      {/* Content & Image Section */}
      <div
        style={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          padding: isMobile ? "20px" : "40px",
          boxSizing: "border-box",
          textAlign: isMobile ? "center" : "left",
          gap: "20px",
        }}
      >
        {/* Content */}
        <p
          style={{
            flex: 1,
            maxWidth: isMobile ? "100%" : "500px",
            lineHeight: "1.5",
            fontSize: isMobile ? "1rem" : "1.2rem",
            color: "#333",
          }}
        >
          <p dangerouslySetInnerHTML={{ __html: selectedTopic.content }}></p>
        </p>

        {/* Image */}
        <img
          src={selectedTopic.image}
          alt={selectedTopic.title}
          style={{
            flex: 1,
            width: isMobile ? "100%" : "30%",
            height: isMobile ? "300px" : "500px",
            borderRadius: "15px",
            transition: "opacity 0.5s ease-in-out",
            objectFit: "cover",
          }}
        />
      </div>
    </div>
  );
};

export default TopicsSection;
